import {
  Typography,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@altimateai/lego";
import type { DropdownEditorProps } from "../types";

const DropdownEditor = ({
  value,
  options,
  onValueChange,
  onValidationError,
}: DropdownEditorProps) => {
  return (
    <div className="al-space-y-3">
      <Typography variant="body" weight="medium" className="al-text-sm">
        Compare to:
      </Typography>
      <Select
        value={String(value)}
        onValueChange={(val) => {
          const option = options.find((opt) => opt.value === val);
          onValueChange(val, option?.label || val);
          onValidationError("");
        }}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default DropdownEditor;
